<script setup lang="ts">
import { useFieldArray } from 'vee-validate'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const STRUCTURE_PATH = 'projekt.financovanie.ineZdrojeFinancovania'

const { remove, push, fields, replace } = useFieldArray(STRUCTURE_PATH)

const defaultValue = computed(() => (fields?.value?.length > 0 ? 'true' : 'false'))
</script>

<template>
  <IDSKRadios
    :model-value="defaultValue"
    :default-value="defaultValue"
    :label="t('zoppm.step11.part3.question')"
    :options="[
      { id: '1', value: 'true', label: t('globalne.ano') },
      { id: '0', value: 'false', label: t('globalne.nie') },
    ]"
    @update:model-value="(value) => (value === 'false' ? replace([]) : push({}))"
  >
    <template #1-hidden-content>
      <div v-for="(field, idx) in fields" :key="field.key">
        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].poskytovatelPomoci`"
        >
          <IDSKInput
            :id="`${STRUCTURE_PATH}[${idx}].poskytovatelPomoci`"
            :label="t('zoppm.step11.part3.helpProviderLabel')"
            v-bind="slotProps"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].nazovPomoci`"
        >
          <IDSKInput
            v-bind="slotProps"
            :id="`${STRUCTURE_PATH}[${idx}].nazovPomoci`"
            :label="t('zoppm.step11.part3.helpNameLabel')"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].rokSchvaleniaPomoci`"
        >
          <IDSKInput
            v-bind="slotProps"
            :name="`${STRUCTURE_PATH}[${idx}].rokSchvaleniaPomoci`"
            :label="t('zoppm.step11.part3.acceptationYearLabel')"
            type="number"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].cisloZmluvy`"
        >
          <IDSKInput
            v-bind="slotProps"
            :id="`${STRUCTURE_PATH}[${idx}].cisloZmluvy`"
            :label="t('zoppm.step11.part3.contractNumLabel')"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].poskytovatelWeb`"
        >
          <IDSKInput
            v-bind="slotProps"
            :id="`${STRUCTURE_PATH}[${idx}].poskytovatelWeb`"
            :label="t('zoppm.step11.part3.providerWebLabel')"
            :hint="t('zoppm.step11.part3.providerWebHint')"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="slotProps"
          :name="`${STRUCTURE_PATH}[${idx}].vyskaPoskytnutychProstriedkov.sumaEur`"
        >
          <IDSKInput
            v-bind="slotProps"
            :id="`${STRUCTURE_PATH}[${idx}].vyskaPoskytnutychProstriedkov.sumaEur`"
            :label="t('zoppm.step11.part3.sumEurLabel')"
            type="number"
          />
        </ValidationWrapper>

        <ValidationWrapper
          v-slot="{ 'onUpdate:modelValue': update, modelValue, ...slotProps }"
          :name="`${STRUCTURE_PATH}[${idx}].vyskaProstriedkovSucastouZoPPM`"
        >
          <IDSKRadios
            v-bind="slotProps"
            :id="`${STRUCTURE_PATH}[${idx}].vyskaProstriedkovSucastouZoPPM`"
            :label="t('zoppm.step11.part3.approvedResources')"
            :model-value="modelValue?.toString()"
            :options="[
              { value: 'true', label: t('globalne.ano') },
              { value: 'false', label: t('globalne.nie') },
            ]"
            class="mb-0"
            @update:model-value="(value) => update(value === 'true')"
          ></IDSKRadios>
        </ValidationWrapper>

        <div v-if="fields.length > 1">
          <IDSKLink
            class="mb-6"
            href="javascript:void(0)"
            no-visited-state
            @click.prevent="remove(idx)"
            >{{ t('globalne.odobratPolozku') }}
          </IDSKLink>
        </div>
      </div>

      <button
        class="idsk-button idsk-button--secondary"
        type="button"
        data-test-id="button-financovanie-pridat-polozku"
        @click="push({})"
      >
        {{ t('globalne.pridatNovuPolozku') }}
      </button>
    </template>
  </IDSKRadios>
</template>

<style lang="scss"></style>
